import { render, staticRenderFns } from "./examBi.vue?vue&type=template&id=54ae5c3a&scoped=true&"
import script from "./examBi.vue?vue&type=script&lang=js&"
export * from "./examBi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ae5c3a",
  null
  
)

export default component.exports